<template>
  <div v-if="total_menu > 0" class="w-100 position-sticky z-index-1041 px-3" style="bottom:85px;">
    <router-link :to="'/'+getMerchant().code+'/cart'">
      <div class="rounded-4 bg-green w-100 px-3 py-2">
        <div class="row no-gutters">
          <div class="col-6">
            <img src="../../assets/img/icon/cart.png" width="20" style="vertical-align: -webkit-baseline-middle">
          </div>
          <div class="col-6 text-right">
            <p class="text-white text-right mb-0 body-2-4" style="font-size: 12px!important">
              {{total_menu > 1 ? `${total_menu} menus` : `${total_menu} menu`}}
            </p>
            <p class="text-white text-right mb-0 body-2-4 text-16">{{formatCurrency(total_price)}}</p>
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>
<script>
	import {mapGetters} from 'vuex';
	import {formatCurrency,calculateFinalPriceConcierge} from '@/utils/index.js'
	export default{
		computed:{
			total_menu(){
				let total = 0
				for(let cart of this.getRestaurantOrder().cart){
					total += cart.qty
				}
				return total
			},
			total_price(){
				let total = 0
				for(let cart of this.getRestaurantOrder().cart){
					if(cart.product.is_variant){
						for(let variant of cart.variant){
							total += calculateFinalPriceConcierge(variant.data.price) * variant.qty
						}
					}else{
						total += calculateFinalPriceConcierge(cart.product.data.price) * cart.qty
					}
				}

				return total
			}
		},
		methods:{
			...mapGetters(['getRestaurantOrderTotal','getMerchant','getRestaurantOrder']),
			formatCurrency(value){
        return formatCurrency(value);
      },
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/restaurant-v2/floatingCart.vue